import { render, staticRenderFns } from "./BoletimMedicaoPlantaFalada.vue?vue&type=template&id=ac18d236&scoped=true&"
import script from "./BoletimMedicaoPlantaFalada.vue?vue&type=script&lang=js&"
export * from "./BoletimMedicaoPlantaFalada.vue?vue&type=script&lang=js&"
import style0 from "./BoletimMedicaoPlantaFalada.vue?vue&type=style&index=0&id=ac18d236&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac18d236",
  null
  
)

export default component.exports